<div class="information-section">
  <h2>Information</h2>
  
  <app-call-to-action
    [feature]="feature">
  </app-call-to-action>
  
  <div class="action-buttons">
    <button pButton (click)="addBlogItem('text')" class="add-text p-button-outlined" label="Add a text" icon="pi pi-file-edit"></button>
    <button pButton (click)="addBlogItem('image')" class="add-image p-button-outlined" label="Add an image" icon="pi pi-image"></button>
  </div>

  <div cdkDropList (cdkDropListDropped)="drop($event)">
    <div *ngFor="let item of feature.value.blogItems; let i = index" class="blog-item" cdkDrag>
      <ng-container [ngSwitch]="item.type">
        <div *ngSwitchCase="'text'" class="text-section">
          <div class="section-header">
            <div class="drag-handle" cdkDragHandle>
              <i class="pi pi-bars"></i>
            </div>
            <h3>Type your text</h3>
            <button pButton icon="pi pi-trash" (click)="removeBlogItem(item)" class="p-button-text p-button-danger delete-button"></button>
          </div>
            <p-editor [(ngModel)]="item.value" [style]="{ height: '320px' }" [modules]="quillConfiguration"></p-editor>
        </div>
        
        <div *ngSwitchCase="'image'" class="image-section">
          <div class="section-header">
            <div class="drag-handle" cdkDragHandle>
              <i class="pi pi-bars"></i>
            </div>
            <h3>Add one image</h3>
            <button pButton icon="pi pi-trash" (click)="removeBlogItem(item)" class="p-button-danger delete-button"></button>
          </div>
          <div class="blog-images">
            <div class="image-preview" *ngFor="let file of item.images; let i = index">
              <img [src]="file.url | safeResourceUrl" alt="Uploaded file">
              <button class="delete-button" (click)="deleteBlogImage(i, item)">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          </div>
          <div *ngIf="!item.images || (item.images && item.images.length == 0)" class="dropzone" appDnd (fileDropped)="blogImageDropped($event, item)">
            <p>Drag and drop 1 image file here</p>
            <p>or</p>
            <a class="browse-link" (click)="fileInput.click()">Browse by clicking here</a>
            <input type="file" #fileInput (change)="blogImageBrowse($event.target.files, item)" style="display:none" accept="image/*">
            <p class="file-info">Compatible formats: jpg, png, gif. Limit of 2 mb</p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>